import styled, { css } from 'styled-components';
import { layout, remCalc, media } from '@prisjakt/ui-base';

import ReviewSummaryBase from '../../components/review-summary';

type InfoLinkProps = {
  showNewReviewSummary?: boolean;
  hasReviews?: boolean;
};

const InfoLink = styled.div<InfoLinkProps>`
  align-self: ${p => (p.showNewReviewSummary ? 'inherit' : 'flex-start')};
  cursor: pointer;
  color: ${p => p.theme.text.callToAction};
  text-align: center;
  line-height: 1.5;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }

  a {
    display: flex;
    align-items: center;
    column-gap: ${layout.spacing.xxSmall};
  }

  a,
  a:hover {
    color: inherit;
  }

  ${p =>
    p.showNewReviewSummary &&
    p.hasReviews &&
    css`
      position: absolute;
      bottom: ${layout.spacing.xSmall};
      right: ${layout.spacing.xSmall};
    `};
`;

const OldReviewsHeader = styled.div`
  padding-top: ${layout.margins.wrapper.desktop.rem};
  border-top: 1px solid ${p => p.theme.lines.primary};
  margin-top: ${layout.margins.component.desktop.rem};

  ${media.mediumDown`
    padding-top: ${layout.margins.wrapper.mobile.rem};
    margin-top: ${layout.margins.component.mobile.rem};
  `}
`;

const SortedBy = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${p => p.theme.text.tertiary};
  font-size: ${remCalc(12)};
`;

const EditButton = styled.button`
  cursor: pointer;
  color: ${p => p.theme.text.callToAction};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

type SummaryProps = {
  showNewReviewSummary?: boolean;
};

const Summary = styled.div.attrs({ 'data-test': 'ReviewsSummary' })<
  SummaryProps
>(
  props => css`
    display: flex;
    flex-direction: row;

    ${props.showNewReviewSummary &&
      css`
        padding: ${layout.spacing.small} ${layout.spacing.medium};
        background: ${props.theme.bg.secondary};
        margin-bottom: ${layout.spacing.xSmall};
        column-gap: ${layout.spacing.xSmall};
        row-gap: ${layout.spacing.small};

        ${media.mediumDown`
          flex-direction: column;
          padding: ${layout.spacing.xSmall};
        `};
      `};
  `
);

type PromptProps = {
  highlighted?: boolean;
  showNewReviewSummary?: boolean;
};

const Prompt = styled.div<PromptProps>`
  margin: ${props => (props.highlighted ? '15px auto' : '0 0 0 auto')};
  text-align: center;

  ${p =>
    p.showNewReviewSummary &&
    css`
      ${media.mediumDown`
        margin: 0;
      `};
    `};
`;

export const ReviewSummary = styled(ReviewSummaryBase)`
  ${media.largeUp`
    width: 500px;
  `};
`;

type SummaryButtons = {
  hasReviews?: boolean;
};

export const SummaryButtons = styled.div<SummaryButtons>(
  props => css`
    position: relative;
    margin-left: auto;
    margin-right: ${props.hasReviews ? 0 : 'auto'};
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: ${layout.spacing.small};

    ${media.mediumDown`
      width: 100%;
      flex-direction: row;
      padding: ${layout.spacing.xSmall};
      justify-content: ${props.hasReviews ? 'space-between' : 'center'};
      align-items: flex-end;
    `};
  `
);

export { InfoLink, OldReviewsHeader, SortedBy, EditButton, Summary, Prompt };
